"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeSurvicate = void 0;
function initializeSurvicate(workspaceKey) {
    if (!workspaceKey)
        console.error('svaKey is missing');
    else {
        var s = document.createElement('script');
        s.src = "https://survey.survicate.com/workspaces/".concat(workspaceKey, "/web_surveys.js");
        s.async = true;
        var e = document.getElementsByTagName('script')[0];
        e.parentNode.insertBefore(s, e);
    }
}
exports.initializeSurvicate = initializeSurvicate;
//# sourceMappingURL=instance.js.map